/* Component Dependencies */
var hwsNavigationTemplate = require('templates/hwsNavigation.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var _ = require('lodash');

AriesComponent.create({
  type: 'hwsNavigation',
  template: {
    'hwsNavigation': hwsNavigationTemplate
  },
  subscribe: {
    'SHOW_HWS_NAVIGATION_BAR': 'showNavigationBar',
    'HIDE_HWS_NAVIGATION_BAR': 'hideNavigationBar'
  },
  bindEvents: function() {
    var _self = this,
      $navigation = window.$('.m-navigation');
    _self.isStickyActive = _self.$el.hasClass('is-lite-site') || _self.$el.hasClass('is-eInterface');
    _self.$window = $(window);
    _self.navigationElement = _self.$el.find('nav');
    $navigation.on('responsiveMenu-init', _self.toggleArrowBorder.call(_self));
    _self.$window.on('resize load', _self.windowResizeFunc.bind(_self));
    _self.tabActiveOnLoad();
    if (_self.isStickyActive) {
      _self.$window.on('scroll orientation', _.debounce(_self.toggleNavHighlight.bind(_self, false), 75));
    }
    // if (_self.$el.hasClass('is-lite-site') || _self.$el.hasClass('is-eInterface')) {
    //   _self.$window.on('scroll orientation touchmove', _.debounce(_self.lockNav.bind(_self), 75));
    // }
    $navigation.on('click', 'li:not(.m-navigation-control)', function() {
      if (!$(this).find('a').data('is-default-site')) {
        _self.removeTabHighlight.call(_self, $(this));
      }
    });
    $navigation.on('click', '.m-navigation-control', _self.toggleNavHighlight.bind(_self, true));
  },
  /**
   * This function is used to  remove multiple highlights from the navigation whenever a link is clicked.
   */
  removeTabHighlight: function(elm) {
				var _self = this, $navBar = $('#stickySummary'), navTargetTopOffset, navHeight, elmIdx;
    if (elm.parent().hasClass('m-navigation-grey-dropdown')) {
      elmIdx = elm.index() + (elm.parents('.m-navigation').find('ul').eq(0).find('li').length - 1);
    } else {
      elmIdx = elm.index();
    }
    _self.$linkArr = _self.$el.find('nav li, .m-navigation-grey-dropdown li');
				navTargetTopOffset = $('.l-nav-target').eq(elmIdx).offset().top;
				navHeight = $navBar.height();
				if( !$navBar.hasClass('is-sticky-top') && navTargetTopOffset > navHeight ) {
					_self.$window.scrollTop(navTargetTopOffset - (navHeight + 150));
				} else {
					_self.$window.scrollTop(navTargetTopOffset - 150);
				}
  },
  /**
   * This function is used to highlight the default tab whenever load event is called.
   */
  tabActiveOnLoad: function() {
    var _self = this;
    _self.firstTab = _self.$el.find('nav > ul > li:nth-of-type(1)');
    if (_self.isStickyActive) {
      _self.firstTab.addClass('highlighted');
    }
  },
  /**
   * This function is executed whenever resize event is called and is globally available for other functions to execute once resize is fired.
   */
  windowResizeFunc: function() {
    var _self = this;
    _self.navOffsetTop = _self.navigationElement.offset().top;
    _self.toggleArrowBorder.call(_self);
  },
  /**
   * This function is used to lock the position of the navigation bar on top of the page whenever scrolled event is fired.
   */
  // lockNav: function() {
  //   var _self = this,
  //     navElementHeight = _self.navigationElement.outerHeight(true),
  //     $searchFormElm = _self.find('.hws-search-form').eq(0);
  //   if (_self.$window.scrollTop() > _self.navOffsetTop) {
  //     _self.navigationElement.addClass('l-sticky-nav');
  //     $searchFormElm.css({ top: navElementHeight, position: 'relative' });
  //   } else {
  //     _self.navigationElement.removeClass('l-sticky-nav');
  //     $searchFormElm.removeAttr('style');
  //   }
  // },
  /**
   * This function is used to iterate over other containers on the page and store the offset value of each containers item from the top in the offsetVal array, for matching with scrollY and finding the trget link to highlight
   */
		offSetValue: function () {
			 var _self = this,
				  $el, elementOffsetTop, subHeaderPadding = 70,
				  $containerElements = $('.l-nav-target');
			 _self.offsetValArr = [];
			 for (var i = 0; i < $containerElements.length; i++) {
				  $el = $containerElements.eq(i);
				  elementOffsetTop = $el.offset().top + subHeaderPadding;
				  _self.offsetValArr.push(elementOffsetTop);
			 }
		},
  /**
   * This function is used to lock the nav bar on top of the page, obtain the position of the scroll, identify the target link to highlight and  add border classes to the navigation bar whenever the content item is scrolled and displayed on viewport
   */
		toggleNavHighlight: function (isCloseClicked) {
			 var _self = this,
				  closestIndex;
				if (!isCloseClicked) {
					 var offsetValArr = [],
						  $nav = $('#stickySummary'),
						  navHeight,
						viewHeight = _self.$window.height(),
						getScrolledVal = _self.$window.scrollTop();
					 _self.offSetValue.call(_self);
					 offsetValArr = _self.offsetValArr.filter(function (elementOffsetTop) {
						  return elementOffsetTop < (getScrolledVal + viewHeight);
					 });
						if (offsetValArr.length) {
							 navHeight = $nav.hasClass('is-sticky-top') ? $nav.height() : 0;
							 for (closestIndex = 0; closestIndex < offsetValArr.length - 1; closestIndex++) {
								  if ((offsetValArr[closestIndex] - navHeight) > getScrolledVal) {
									   break;
								  }
							 }
						 	_self.closestIndex = closestIndex;
						} else {
							 _self.closestIndex = 0;
						}
						_self.$linkArr = this.$el.find('nav li:not(.m-navigation-control)');
					 _self.$linkArr.removeClass('highlighted').eq(_self.closestIndex).addClass('highlighted');
				} else {
					 if (typeof _self.closestIndex !== 'undefined') {
						  _self.$linkArr.removeClass('highlighted').eq(_self.closestIndex).addClass('highlighted');
					 }
				}
		},

  /**
   * This function is used to add border classes to the navigation arrow whenever the active item is inside the dropdown and vice-versa
   * @return {boolean} operation success or not
   */
  toggleArrowBorder: function() {
    var dropdown = this.$el.find('.m-navigation-grey-dropdown');
    dropdown.addClass('t-brand-mv');

    if (dropdown.length) {
      if (dropdown.find('.active').length) {
        this.$el.find('.m-navigation-control').addClass('active-border').addClass('t-border-bottom-thin-brand');
      } else {
        this.$el.find('.m-navigation-control').removeClass('active-border').removeClass('t-border-bottom-thin-brand');
      }
    }
  },
  /**
   * This function is used to show hws navigation bar once search field(calendar/room-guest-section) get closed or sticky behaviour is removed to navigation bar
   */
  showNavigationBar: function() {
    this.$el.slideDown();
  },
  /**
   * This function is used to hide hws navigation bar once search field(calendar/room-guest-section) get active and sticky behaviour is added to navigation bar
   */
  hideNavigationBar: function() {
    this.$el.slideUp();
  }
});
